var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBottomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.4694L1.192 12.7647L3.13136 0.800487C3.13136 0.800487 6.31326 0.124391 14.7187 0.800487L17 14.6701C17 14.6701 15.9798 15.5067 13.458 16.0136C11.1486 16.4779 10.2268 16.3752 10.2268 16.3752C10.0659 16.3985 9.88674 16.244 9.82956 16.0306L9.04412 9.65691C8.99754 9.48305 9.0782 9.47751 9.04412 9.65691L8.21892 16.1053C8.17044 16.3602 7.99661 16.5265 7.81029 16.4965L5.35248 16.0982C2.42773 15.6244 1 14.4694 1 14.4694Z",
    fill: "white",
    stroke: "#6D7283",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8987 2.10645H2.9509C2.67671 2.10645 2.67633 2.70588 2.9509 2.70588H14.8987C15.1729 2.70588 15.1733 2.10645 14.8987 2.10645Z",
    fill: "#6D7283"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28291 15.1656C5.91751 14.8103 3.59679 14.1749 1.36886 13.2728C1.05074 13.144 0.912893 13.6786 1.22798 13.8063C3.45553 14.7084 5.77663 15.3438 8.14203 15.699C8.28481 15.7203 8.42493 15.6623 8.4681 15.5058C8.5037 15.3762 8.42417 15.1865 8.28291 15.1656Z",
    fill: "#6D7283"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5587 13.4996C14.3808 14.3076 12.1142 14.8478 9.80749 15.1078C9.47801 15.1449 9.60109 15.6823 9.92754 15.6456C12.2346 15.3852 14.5008 14.8454 16.6787 14.0373C16.8102 13.9887 16.9037 13.8706 16.87 13.7121C16.842 13.581 16.689 13.4513 16.5587 13.4996Z",
    fill: "#6D7283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBottomIcon);
export default __webpack_public_path__ + "static/media/home-bottom-icon.ef83487741be15a2ce59c2f40e616c65.svg";
export { ForwardRef as ReactComponent };